// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".styles-module__fullWidthRowContainer___NO5wT {\n  width: 100vw;\n  margin-left: calc(-50vw + 50%);\n}\n", "",{"version":3,"sources":["webpack://common/components/ui/full-width-container/styles.module.less"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,8BAAA;AACF","sourcesContent":[".fullWidthRowContainer {\n  width: 100vw;\n  margin-left: calc(-50vw + 50%);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fullWidthRowContainer": "styles-module__fullWidthRowContainer___NO5wT"
};
export default ___CSS_LOADER_EXPORT___;
